/**
 * Clerk session token for API calls and the host socket.
 *
 * window.Clerk is set globally by ClerkProvider. Clerk session tokens live
 * for about one minute. getToken() returns a cached token while it is valid
 * and gets a new one when it expires, so call this for each request and for
 * each socket connection attempt. Do not store the result.
 */
type ClerkLike = { session?: { getToken: () => Promise<string | null> } | null };

export async function getClerkToken(): Promise<string | null> {
  const clerk = (window as unknown as { Clerk?: ClerkLike }).Clerk;
  if (!clerk?.session) return null;
  try {
    return await clerk.session.getToken();
  } catch {
    return null;
  }
}

/**
 * socket.io `auth` option for the host socket. socket.io calls this
 * function on the first connection and again on every reconnect, so each
 * attempt sends a fresh token. A host whose token expired while the
 * network was down gets a new token on reconnect and keeps control.
 * With no token, the server falls back to the legacy JWT cookie.
 */
export function socketAuth(cb: (data: Record<string, unknown>) => void): void {
  getClerkToken().then(
    (token) => cb(token ? { token } : {}),
    () => cb({}),
  );
}
